var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.menu.content ? _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading
    }
  }, [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', [_vm._v("LINE 主控台")]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'RichMenu'
      }
    }
  }, [_vm._v("圖文選單")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-2"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.title))])])]), _c('h5', [_vm._v("基本設定")]), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label text-right"
  }, [_vm._v("* 標題")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('b-form-input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "輸入標題",
      "state": _vm.v$.menu.title.$error ? false : null,
      "maxlength": "100",
      "required": "",
      "disabled": _vm.isReadonly
    },
    model: {
      value: _vm.menu.title,
      callback: function callback($$v) {
        _vm.$set(_vm.menu, "title", $$v);
      },
      expression: "menu.title"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.menu.title.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)]), _c('div', {
    staticClass: "form-group form-row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label text-right"
  }, [_vm._v("* 開始時間")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "input-class": _vm.v$.menu.start_at.date.$error ? 'is-invalid' : '',
      "disabled": _vm.isReadonly
    },
    model: {
      value: _vm.menu.start_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.menu.start_at, "date", $$v);
      },
      expression: "menu.start_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.menu.start_at.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "col-sm-3 timepicker"
  }, [_c('vue-timepicker', {
    attrs: {
      "input-class": "".concat(_vm.v$.menu.start_at.time.HH.$error || _vm.v$.menu.start_at.time.mm.$error ? 'is-invalid' : '', " form-control"),
      "hide-clear-button": "",
      "disabled": _vm.isReadonly
    },
    model: {
      value: _vm.menu.start_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.menu.start_at, "time", $$v);
      },
      expression: "menu.start_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.menu.start_at.time.HH.$error && !_vm.v$.menu.start_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)]), _vm.v$.startAt.$error ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('small', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.v$.startAt.$errors[0].$message))])])]) : _vm._e()])]), _c('div', {
    staticClass: "form-group form-row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label text-right"
  }, [_vm._v("* 結束時間")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('datepicker', {
    staticClass: "flex-fill",
    attrs: {
      "placeholder": "日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "input-class": _vm.v$.menu.end_at.date.$error ? 'is-invalid' : '',
      "disabled": _vm.isReadonly
    },
    model: {
      value: _vm.menu.end_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.menu.end_at, "date", $$v);
      },
      expression: "menu.end_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.menu.end_at.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "col-sm-3 timepicker"
  }, [_c('vue-timepicker', {
    attrs: {
      "input-class": "".concat(_vm.v$.menu.end_at.time.HH.$error || _vm.v$.menu.end_at.time.mm.$error ? 'is-invalid' : '', " form-control"),
      "hide-clear-button": "",
      "disabled": _vm.isReadonly
    },
    model: {
      value: _vm.menu.end_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.menu.end_at, "time", $$v);
      },
      expression: "menu.end_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.menu.end_at.time.HH.$error && !_vm.v$.menu.end_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)]), _vm.v$.endAt.$error ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, _vm._l(_vm.v$.endAt.$errors, function (error) {
    return _c('small', {
      key: error.$uid,
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(error.$message)), _c('br')]);
  }), 0)]) : _vm._e()])]), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label text-right pr-0"
  }, [_c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "title": "初始會看到的選單"
    }
  }, [_vm._v("預設選單")])]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('b-form-radio-group', {
    staticClass: "mt-2",
    attrs: {
      "options": [{
        text: '是',
        value: true
      }, {
        text: '否',
        value: false
      }],
      "disabled": _vm.isReadonly
    },
    model: {
      value: _vm.menu.is_default,
      callback: function callback($$v) {
        _vm.$set(_vm.menu, "is_default", $$v);
      },
      expression: "menu.is_default"
    }
  })], 1)]), _c('hr'), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "mr-4"
  }, [_vm.menu.content.name !== 'custom' ? _c('div', {
    staticClass: "preview-popover custom-preview-popover mb-2"
  }, [_c('div', {
    staticClass: "preview-icon"
  }), _c('div', {
    staticClass: "flex-fill"
  }, [_c('div', [_vm._v("框選處為可點擊的範圍")]), _c('div', [_vm._v("(設定使用者點擊後觸發的內容)")])]), _c('div', {
    staticClass: "preview-popover__nub"
  })]) : _vm._e(), _c('div', [_vm._v("預覽")]), _c('div', {
    staticClass: "position-relative"
  }, [_c('Preview', {
    ref: "preview",
    attrs: {
      "id": "customPreview",
      "image-url": _vm.imageFile || _vm.menu.image_url,
      "content": _vm.menu.content,
      "is-customized-template": _vm.isCustomizedTemplate,
      "is-customing": _vm.isCustoming
    },
    on: {
      "is-customing": function isCustoming(val) {
        return _vm.isCustoming = val;
      },
      "custom-save": _vm.customSave
    }
  }), _vm.showPreviewPopover ? _c('button', {
    staticClass: "close-button position-absolute",
    on: {
      "click": function click() {
        return _vm.showPreviewPopover = false;
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/close.svg")
    }
  })]) : _vm._e(), _vm.showPreviewPopover ? _c('div', {
    staticClass: "preview-popover custom-preview-popover position-absolute mx-1",
    style: {
      bottom: '50%'
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/move.svg")
    }
  }), _c('div', {
    staticClass: "ml-1"
  }, [_vm._v("拖曳游標")]), _c('div', {
    staticClass: "preview-icon"
  }), _c('div', {
    staticClass: "ml-1"
  }, [_vm._v("建立 使用者 \"點擊後\" 觸發的區塊範圍")]), _c('div', {
    staticClass: "preview-popover__nub"
  })]) : _vm._e(), _c('SpotlightHole', {
    attrs: {
      "target": '#customPreview',
      "visible": _vm.showPreviewPopover,
      "padding": {
        top: 28,
        bottom: 4,
        right: 4,
        left: 4
      },
      "radius": 4,
      "backdropOpacity": 0.6,
      "zIndex": 9999
    }
  })], 1)]), _c('div', {
    staticClass: "flex-fill"
  }, [_c('h5', [_vm._v("內容設定")]), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("版型")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-template",
      modifiers: {
        "modal-template": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "disabled": _vm.isReadonly
    }
  }, [_vm._v("選擇")]), _vm.menu.content ? _c('b-modal', {
    staticClass: "modal-template",
    attrs: {
      "id": "modal-template",
      "centered": "",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-title",
      fn: function fn() {
        return [_c('div', [_vm._v("選擇版型")]), _c('div', {
          staticStyle: {
            "color": "#45a9f8",
            "font-size": "0.8rem"
          }
        }, [_vm._v("* 如欲使用 切換圖文選單 功能，請選擇 自訂版型")])];
      },
      proxy: true
    }], null, false, 3509265327)
  }, [_c('div', {
    staticClass: "h5"
  }, [_vm._v("大型")]), _c('div', [_vm._v("適合顯示版面較大或項目較多的圖文選單。")]), _c('small', [_vm._v("圖片尺寸建議：2500px × 1686px ／ 1200px × 810px ／ 800px × 540px")]), _c('div', {
    staticClass: "d-flex flex-wrap justify-content-start mt-3"
  }, _vm._l(_vm.menuBigTemplate, function (t, tdx) {
    return _c('div', {
      key: tdx,
      staticClass: "template template-big p-2"
    }, [t.areas.length > 0 ? _c('button', {
      class: "btn btn-link border border-".concat(_vm.templateIndex == tdx ? 'success' : 'secondary', " rounded-0"),
      on: {
        "click": function click($event) {
          return _vm.switchTemplate(t, tdx);
        }
      }
    }, _vm._l(t.areas, function (a, adx) {
      return _c('div', {
        key: adx,
        class: "action border border-".concat(_vm.templateIndex == tdx ? 'success' : 'secondary'),
        style: {
          left: "".concat(a.bounds.x / t.size.width * 100, "%"),
          top: "".concat(a.bounds.y / t.size.height * 100, "%"),
          width: "".concat(a.bounds.width / t.size.width * 100, "%"),
          height: "".concat(a.bounds.height / t.size.height * 100, "%")
        }
      });
    }), 0) : _c('div', {
      staticClass: "d-flex align-items-center position-relative"
    }, [_c('button', {
      class: "btn btn-link border border-".concat(_vm.templateIndex == tdx ? 'success' : 'secondary', " rounded-0"),
      on: {
        "click": function click($event) {
          return _vm.switchTemplate(t, tdx);
        }
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-center align-items-center",
      class: "action border border-".concat(_vm.templateIndex == tdx ? 'success' : 'secondary'),
      style: {
        left: 0,
        top: 0,
        width: '100%',
        height: '100%'
      }
    }, [_vm._v(" 自訂 ")])]), _c('img', {
      staticClass: "hint-img",
      attrs: {
        "src": require("@/assets/images/question.png"),
        "alt": "自訂說明"
      },
      on: {
        "click": function click() {
          return _vm.showCustomTemplateHint = true;
        }
      }
    })])]);
  }), 0), _c('div', {
    staticClass: "h5 mt-3"
  }, [_vm._v("小型")]), _c('div', [_vm._v("適合顯示版面較小或項目較少的圖文選單。")]), _c('small', [_vm._v("圖片尺寸建議：2500px × 843px ／ 1200px × 405px ／ 800px × 270px")]), _c('div', {
    staticClass: "d-flex flex-wrap justify-content-start mt-3"
  }, _vm._l(_vm.menuSmallTemplate, function (t, tdx) {
    return _c('div', {
      key: tdx,
      staticClass: "template template-small p-2"
    }, [t.areas.length > 0 ? _c('button', {
      class: "btn btn-link border border-".concat(_vm.templateIndex == tdx + _vm.menuBigTemplate.length ? 'success' : 'secondary', " rounded-0"),
      on: {
        "click": function click($event) {
          return _vm.switchTemplate(t, tdx + _vm.menuBigTemplate.length);
        }
      }
    }, _vm._l(t.areas, function (a, adx) {
      return _c('div', {
        key: adx,
        class: "action border border-".concat(_vm.templateIndex == tdx + _vm.menuBigTemplate.length ? 'success' : 'secondary'),
        style: {
          left: "".concat(a.bounds.x / t.size.width * 100, "%"),
          top: "".concat(a.bounds.y / t.size.height * 100, "%"),
          width: "".concat(a.bounds.width / t.size.width * 100, "%"),
          height: "".concat(a.bounds.height / t.size.height * 100, "%")
        }
      });
    }), 0) : _c('div', {
      staticClass: "d-flex align-items-center position-relative"
    }, [_c('button', {
      class: "btn btn-link border border-".concat(_vm.templateIndex == tdx + _vm.menuBigTemplate.length ? 'success' : 'secondary', " rounded-0"),
      on: {
        "click": function click($event) {
          return _vm.switchTemplate(t, tdx + _vm.menuBigTemplate.length);
        }
      }
    }, [_c('div', {
      staticClass: " d-flex justify-content-center align-items-center ",
      class: "action border border-".concat(_vm.templateIndex == tdx ? 'success' : 'secondary'),
      style: {
        left: 0,
        top: 0,
        width: '100%',
        height: '100%'
      }
    }, [_vm._v(" 自訂 ")])]), _c('img', {
      staticClass: "hint-img",
      attrs: {
        "src": require("@/assets/images/question.png"),
        "alt": "自訂說明"
      },
      on: {
        "click": function click() {
          return _vm.showCustomTemplateHint = true;
        }
      }
    })])]);
  }), 0)]) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "modal-template-custom-hint",
      "centered": "",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-title",
      fn: function fn() {
        return [_c('div', {
          staticClass: "pt-2 font-weight-bold",
          staticStyle: {
            "font-size": "1rem"
          }
        }, [_vm._v("自訂版型：任意拖曳框選處，即為可點擊範圍")])];
      },
      proxy: true
    }], null, false, 3434779669),
    model: {
      value: _vm.showCustomTemplateHint,
      callback: function callback($$v) {
        _vm.showCustomTemplateHint = $$v;
      },
      expression: "showCustomTemplateHint"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.8rem"
    }
  }, [_c('div', {
    staticClass: "font-weight-bold mb-1"
  }, [_vm._v("舉例：如欲使用【切換圖文選單】功能")]), _c('div', [_vm._v("➊ 選擇 \"自訂\" 版型，上傳圖片後先儲存草稿 (* 欲切換 2 個圖檔，需新增 2 筆圖文選單)。")]), _c('div', [_vm._v("➋ 編輯先前存入草稿的圖文選單，逐一拖曳游標，建立點擊觸發區塊。")]), _c('div', [_vm._v("➌ 類型點選【切換圖文選單】，並選擇要顯示的圖文選單標題。")])])])], 1)]), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("圖片")]), _c('div', {
    staticClass: "col-sm-10 image-selector"
  }, [_vm.imageFile || _vm.menu.image_url ? _c('div', {
    staticClass: "image",
    style: {
      aspectRatio: "".concat(_vm.menu.content.size.width, "/").concat(_vm.menu.content.size.height)
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.imageFile != null ? _vm.imageFile : _vm.menu.image_url
    }
  }), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.imageFile = _vm.menu.image_url = null;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times m-0"
  })])]) : _c('div', {
    staticClass: "selector",
    style: {
      aspectRatio: "".concat(_vm.menu.content.size.width, "/").concat(_vm.menu.content.size.height)
    }
  }, [_c('ImageSelector', {
    staticClass: "\n                  border\n                  h-100\n                  d-flex\n                  justify-content-center\n                  align-items-center\n                ",
    class: {
      'border-danger': _vm.v$.imageFile.$error
    },
    attrs: {
      "aspect-ratio": _vm.menu.content.size.width / _vm.menu.content.size.height,
      "show-error": _vm.v$.imageFile.$error
    },
    on: {
      "input": _vm.selectImage
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function fn(_ref) {
        var openFileSelector = _ref.openFileSelector;
        return [_c('button', {
          staticClass: "btn s-trigger-btn",
          on: {
            "click": openFileSelector
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v(" 圖片 ")])];
      }
    }, {
      key: "content",
      fn: function fn() {
        return [_c('small', {
          staticClass: "text-center mb-2"
        }, [_vm._v("｜檔案格式：JPG、JPEG、PNG｜檔案大小：1MB 以下")])];
      },
      proxy: true
    }], null, false, 1961136369)
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.imageFile.$error
    }
  }, [_vm._v(" 請選取圖片 ")])], 1)])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("編輯欄位 "), _vm.menu.content.name == 'custom' ? _c('small', {
    class: !_vm.isCustoming && 'text-muted'
  }, [_vm._v("左方預覽區，點擊 \"套用自訂欄位\" 完成後可進行內容編輯")]) : _vm._e()]), _vm._l(_vm.menu.content.areas, function (i, idx) {
    return _c('b-card', {
      key: idx,
      staticClass: "mb-2 shadow-none",
      attrs: {
        "no-body": ""
      }
    }, [_c('b-card-header', {
      staticClass: "p-1",
      attrs: {
        "header-tag": "header",
        "role": "tab"
      }
    }, [_c('b-button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: "accordion-".concat(idx),
        expression: "`accordion-${idx}`"
      }],
      staticClass: "\n                  text-left\n                  d-flex\n                  justify-content-between\n                  text-decoration-none\n                ",
      attrs: {
        "block": "",
        "variant": "link"
      }
    }, [_vm._v(" " + _vm._s(["A", "B", "C", "D", "E", "F"][idx]) + " "), _c('i', {
      staticClass: "fa",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1), _c('b-collapse', {
      attrs: {
        "id": "accordion-".concat(idx),
        "visible": "",
        "accordion": "accordion"
      }
    }, [_c('b-card-body', [_c('div', {
      staticClass: "form-group row"
    }, [_c('label', {
      staticClass: "col-sm-2 col-form-label text-right"
    }, [_vm._v("類型")]), _c('div', {
      staticClass: "col-sm-10"
    }, [_c('b-select', {
      attrs: {
        "disabled": _vm.isReadonly
      },
      model: {
        value: i.action.type,
        callback: function callback($$v) {
          _vm.$set(i.action, "type", $$v);
        },
        expression: "i.action.type"
      }
    }, [_c('b-select-option', {
      attrs: {
        "value": "null"
      }
    }, [_vm._v("請選擇")]), _c('b-select-option', {
      attrs: {
        "value": "uri"
      }
    }, [_vm._v("連結")]), _c('b-select-option', {
      attrs: {
        "value": "message"
      }
    }, [_vm._v("文字訊息")]), _c('b-select-option', {
      attrs: {
        "value": "richmenuswitch"
      }
    }, [_vm._v("切換圖文選單")]), _c('b-select-option', {
      attrs: {
        "value": "tel"
      }
    }, [_vm._v("電話")])], 1)], 1)]), _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "offset-sm-2 col-sm-10"
    }, [i.action.type == 'uri' ? [_c('b-input', {
      staticClass: "form-control",
      attrs: {
        "type": "url",
        "placeholder": "輸入網址",
        "required": "",
        "state": !_vm.v$.$dirty || _vm.menuValidator.content.areas[idx].validUri ? null : false,
        "disabled": _vm.isReadonly
      },
      model: {
        value: i.action.uri,
        callback: function callback($$v) {
          _vm.$set(i.action, "uri", $$v);
        },
        expression: "i.action.uri"
      }
    }), _c('b-form-invalid-feedback', {
      attrs: {
        "state": !_vm.v$.$dirty || _vm.menuValidator.content.areas[idx].validUri ? null : false
      }
    }, [_vm._v(" 請填入正確連結 ")])] : _vm._e(), i.action.type == 'message' ? [_c('b-input', {
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "輸入文字",
        "required": "",
        "state": !_vm.v$.$dirty || _vm.menuValidator.content.areas[idx].validText ? null : false,
        "disabled": _vm.isReadonly
      },
      model: {
        value: i.action.text,
        callback: function callback($$v) {
          _vm.$set(i.action, "text", $$v);
        },
        expression: "i.action.text"
      }
    }), _c('b-form-invalid-feedback', {
      attrs: {
        "state": !_vm.v$.$dirty || _vm.menuValidator.content.areas[idx].validText ? null : false
      }
    }, [_vm._v(" 請填入文字，且長度小於 300 ")])] : _vm._e(), i.action.type == 'richmenuswitch' ? [_c('b-select', {
      attrs: {
        "options": _vm.richMenus,
        "disabled": _vm.isReadonly
      },
      scopedSlots: _vm._u([{
        key: "first",
        fn: function fn() {
          return [_c('b-form-select-option', {
            attrs: {
              "value": null,
              "disabled": _vm.isReadonly
            }
          }, [_vm._v("-- 請選擇 --")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: i.action.data,
        callback: function callback($$v) {
          _vm.$set(i.action, "data", $$v);
        },
        expression: "i.action.data"
      }
    }), _c('b-form-invalid-feedback', {
      attrs: {
        "state": !_vm.v$.$dirty || _vm.menuValidator.content.areas[idx].validData ? null : false
      }
    }, [_vm._v(" 請選擇圖文選單 ")])] : _vm._e(), i.action.type == 'tel' ? [_c('b-input', {
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "輸入電話",
        "required": "",
        "state": !_vm.v$.$dirty || _vm.menuValidator.content.areas[idx].phoneNumber ? null : false,
        "disabled": _vm.isReadonly
      },
      model: {
        value: i.action.phoneNumber,
        callback: function callback($$v) {
          _vm.$set(i.action, "phoneNumber", $$v);
        },
        expression: "i.action.phoneNumber"
      }
    }), _c('b-form-invalid-feedback', {
      attrs: {
        "state": !_vm.v$.$dirty || _vm.menuValidator.content.areas[idx].phoneNumber ? null : false
      }
    }, [_vm._v(" 請填入電話 ")])] : _vm._e()], 2)]), i.action.type == 'uri' || i.action.type == 'tel' ? _c('div', {
      staticClass: "form-group row"
    }, [_c('label', {
      staticClass: "col-sm-2 col-form-label text-right"
    }, [_vm._v("動作標籤")]), _c('div', {
      staticClass: "col-sm-10"
    }, [_c('b-textarea', {
      attrs: {
        "rows": "6",
        "placeholder": "輸入動作標籤的說明",
        "state": !_vm.v$.$dirty || _vm.menuValidator.content.areas[idx].validDisplayText ? null : false,
        "disabled": _vm.isReadonly
      },
      model: {
        value: i.action.displayText,
        callback: function callback($$v) {
          _vm.$set(i.action, "displayText", $$v);
        },
        expression: "i.action.displayText"
      }
    }), _c('b-form-invalid-feedback', {
      attrs: {
        "state": !_vm.v$.$dirty || _vm.menuValidator.content.areas[idx].validDisplayText ? null : false
      }
    }, [_vm._v(" 此欄位為必填 ")])], 1)]) : _vm._e()])], 1)], 1);
  })], 2), _c('div', {
    staticClass: "h5 mt-3"
  }, [_vm._v("設定選單列")]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-4 text-right"
  }, [_c('label', {
    staticClass: "col-form-label d-block"
  }, [_vm._v("選單列顯示文字")]), _c('small', {
    staticClass: "text-muted text-left"
  }, [_vm._v("顯示於圖表下方顯示之文字")])]), _c('b-form-group', {
    staticClass: "col-sm-8",
    attrs: {
      "disabled": _vm.isReadonly
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": false
    },
    on: {
      "change": function change($event) {
        _vm.menu.content.chatBarText = '選單';
      }
    },
    model: {
      value: _vm.customChatbar,
      callback: function callback($$v) {
        _vm.customChatbar = $$v;
      },
      expression: "customChatbar"
    }
  }, [_vm._v(" 選單 ")]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-radio', {
    staticClass: "text-nowrap mr-2",
    attrs: {
      "value": true
    },
    on: {
      "change": function change($event) {
        _vm.menu.content.chatBarText = '';
      }
    },
    model: {
      value: _vm.customChatbar,
      callback: function callback($$v) {
        _vm.customChatbar = $$v;
      },
      expression: "customChatbar"
    }
  }, [_vm._v("自訂文字")]), _c('b-form-input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "自訂文字",
      "maxlength": "14",
      "disabled": !_vm.customChatbar || _vm.isReadonly
    },
    model: {
      value: _vm.menu.content.chatBarText,
      callback: function callback($$v) {
        _vm.$set(_vm.menu.content, "chatBarText", $$v);
      },
      expression: "menu.content.chatBarText"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-4 text-right"
  }, [_c('label', {
    staticClass: "col-form-label d-block"
  }, [_vm._v("預設顯示方式")]), _c('small', {
    staticClass: "text-muted text-left"
  }, [_vm._v("進入官方帳號時是否顯示選單")])]), _c('b-form-group', {
    staticClass: "col-sm-8",
    attrs: {
      "disabled": _vm.isReadonly
    }
  }, [_c('b-form-radio', {
    staticClass: "py-2",
    attrs: {
      "value": true
    },
    model: {
      value: _vm.menu.content.selected,
      callback: function callback($$v) {
        _vm.$set(_vm.menu.content, "selected", $$v);
      },
      expression: "menu.content.selected"
    }
  }, [_vm._v("顯示")]), _c('b-form-radio', {
    staticClass: "py-2",
    attrs: {
      "value": false
    },
    model: {
      value: _vm.menu.content.selected,
      callback: function callback($$v) {
        _vm.$set(_vm.menu.content, "selected", $$v);
      },
      expression: "menu.content.selected"
    }
  }, [_vm._v("隱藏")])], 1)], 1)])]), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-fill d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("返回")]), !_vm.isReadonly ? _c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.save('');
      }
    }
  }, [_vm._v(_vm._s(_vm.saveTitle))]) : _vm._e(), _vm.showSaveAndSetSchedule ? _c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.save('set-schedule');
      }
    }
  }, [_vm._v("預約上線")]) : _vm._e(), _vm.showSaveAndPublish ? _c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.save('publish');
      }
    }
  }, [_vm._v("立即上線")]) : _vm._e()], 1)])])], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }